﻿(function (angular, location, scroll) {
    'use strict';

    var DEALER_CODE_PARAM_KEY = 'dc';
    var SAP_DEALER_CODE_PARAM_KEY = 'spc';
    var BRANCH_CODE_PARAM_KEY = 'bc';

    angular
        .module('Toyota.Directives')
        .directive('tyBookAServiceOsbTransform', ['$location', function ($location) {
            var controller = ['$scope', '$element', '$sce', '$filter', '$timeout', 'UrlParser',
                function ($scope, $element, $sce, $filter, $timeout, UrlParser) {
                    var bookAServiceOsbTransformController = this;

                    $scope.init = function () {
                        $scope.showIframe = false;
                    };

                    $scope.init();

                    bookAServiceOsbTransformController.constructSourceUrl = function (dealerCode, sapDealerCode, branchCode, vin, odometer) {
                        var returnUrl = UrlParser.overrideUrlQueryStringFromMap(
                            location.href,
                            {
                                [SAP_DEALER_CODE_PARAM_KEY]: undefined,
                                [BRANCH_CODE_PARAM_KEY]: undefined,
                            });

                        if(!vin) {
                            var url =
                                $filter('formatArgs')('{0}/booking/dealer/{1}/{2}/{3}?iframe=true&returnurl={4}&bookingsource=Toyota.com&supresspopup=true', [
                                    bookAServiceOsbTransformController.baseUrl,
                                    sapDealerCode ?? dealerCode,
                                    branchCode,
                                    bookAServiceOsbTransformController.key,
                                    encodeURIComponent(returnUrl)
                            ]);
                        } else {
                            var url =
                                $filter('formatArgs')('{0}/booking/dealer/{1}/{2}/{3}?iframe=true&vin={4}&odometer={5}&returnurl={6}&bookingsource=Toyota.com&supresspopup=true', [
                                    bookAServiceOsbTransformController.baseUrl,
                                    sapDealerCode ?? dealerCode,
                                    branchCode,
                                    bookAServiceOsbTransformController.key,
                                    vin,
                                    odometer ?? "",
                                    encodeURIComponent(returnUrl)
                            ]);
                        }

                        return url;
                    };

                    bookAServiceOsbTransformController.scrollToOsbTop = function () {
                        var elTopInViewport = $element.get(0).getBoundingClientRect().top;
                        var scrollTop = angular.element(window).scrollTop();
                        scroll(0, elTopInViewport + scrollTop);
                    };

                    bookAServiceOsbTransformController.showAndScrollToIframe = function () {
                        $scope.showIframe = true;
                        $timeout(function () {
                            bookAServiceOsbTransformController.scrollToOsbTop();
                        });
                    };

                    bookAServiceOsbTransformController.setSourceUrl = function (url) {
                        $scope.iframeSrc = $sce.trustAsResourceUrl(url);
                    };
                }
            ];

            return {
                scope: true,
                restrict: 'A',
                controller: controller,
                controllerAs: 'bookAServiceOsbTransformController',
                bindToController: {
                    baseUrl: '@tyBookAServiceOsbTransformBaseUrl',
                    key: '@tyBookAServiceOsbTransformKey'
                },
                link: function (scope, elm, attrs, ctrl) {
                    var dealerCodeParam = $location.search()[DEALER_CODE_PARAM_KEY];
                    var sapdealerCodeParam = $location.search()[SAP_DEALER_CODE_PARAM_KEY];
                    var branchCodeParam = $location.search()[BRANCH_CODE_PARAM_KEY];

                    if ((sapdealerCodeParam || dealerCodeParam) && branchCodeParam) {
                        var sourceUrl = ctrl.constructSourceUrl(dealerCodeParam, sapdealerCodeParam, branchCodeParam);
                        ctrl.setSourceUrl(sourceUrl);
                        ctrl.showAndScrollToIframe();
                    }
                }
            };
        }]);
})(window.angular, window.location, window.scroll);